import { useContext } from 'react';
import { GridContext } from 'contexts/GridContext';
import { GeodataContext } from 'contexts/GeodataContext';
import FileCoordinates from 'views/add-grid/FileCoordinates';
import ProjectImportedFileDialog, { type ProjectImportedFile } from './ProjectImportedFileDialog';

interface UploadCustomObjectsProps {
  readOnly?: boolean;
  storageImportDisabled?: boolean;
  projectId: string | null;
}

const UploadCustomObjects = ({
  readOnly = false,
  storageImportDisabled = false,
  projectId,
}: UploadCustomObjectsProps) => {
  const { coordinateSystemPreference, setCoordinateSystemPreference } = useContext(GridContext);
  const { geodataParams, setGeodataParams } = useContext(GeodataContext);
  return (
    <div className="geodata-section-block geodata-section-block--uploads">
      <div className="geodata-subaccordion__trigger">Project Sketch:</div>
      <div className="geodata-subaccordion__content">
        <ProjectImportedFileDialog
          projectId={projectId}
          kind="projectSketches"
          selectLabel="Select"
          selectedFile={geodataParams?.fileForProjectSketches as ProjectImportedFile | null}
          onSelect={(file) => setGeodataParams({ fileForProjectSketches: file })}
          onClear={() => setGeodataParams({ fileForProjectSketches: null })}
          disabled={readOnly}
          uploadDisabled={storageImportDisabled}
        />
      </div>

      <div className="geodata-subaccordion__trigger">Custom Obstruction:</div>
      <div className="geodata-subaccordion__content">
        <ProjectImportedFileDialog
          projectId={projectId}
          kind="customObstruction"
          selectLabel="Select"
          selectedFile={geodataParams?.fileForCustomObstructions as ProjectImportedFile | null}
          onSelect={(file) => setGeodataParams({ fileForCustomObstructions: file })}
          onClear={() => setGeodataParams({ fileForCustomObstructions: null })}
          disabled={readOnly}
          uploadDisabled={storageImportDisabled}
        />
      </div>

      <div className="geodata-custom-objects__coordinates">
        <FileCoordinates value={coordinateSystemPreference} onChange={setCoordinateSystemPreference} />
      </div>
    </div>
  );
};

export default UploadCustomObjects;
